import type { FC } from 'react';
import React from 'react';

import { getFirstSymbolFromIssuerName } from '../../helpers';

import type { TLogo } from './models';

export const Logo: FC<TLogo> = ({
    Icon,
    Text,
    assetName,
    backgroundColor = '#dbdee1',
    issuer,
    mainSize,
    size,
    textView = 'medium',
}) => {
    const issuerLogoPath = issuer?.logo?.path;

    return (
        <Icon
            backgroundColor={backgroundColor}
            imageUrl={issuerLogoPath}
            mainSize={mainSize}
            size={size}
        >
            {!issuerLogoPath && (
                <Text kind="caption" styler={{ margin: 0 }} view={textView}>
                    {getFirstSymbolFromIssuerName(assetName)}
                </Text>
            )}
        </Icon>
    );
};
